import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { RESERVATION_BASE_URL, REPORTING_BASE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class DealerReportingClient {
  static baseUrl = RESERVATION_BASE_URL;
  static reportingUrl = REPORTING_BASE_URL;

  static downloadOrderStatusReportInCsv(user, lang) {
    const commonIds = user.getCommonIdsWithSDLR
      ? user.getCommonIdsWithSDLR().split(",")
      : user.commonId.split("|").join("%7C");
    const url = `${this.baseUrl}/dealer/order-status-report?dealerCommonId=${commonIds}&lang=${lang}`;
    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }

  static downloadOrderStatusReportInXlsx(user, lang) {
    const commonIds = user.getCommonIdsWithSDLR
      ? user.getCommonIdsWithSDLR().split("%7C").join("|")
      : user.commonId;
    const requestBody = {
      marketId: user.market,
      commonIds: commonIds,
      langCode: lang,
    };

    const url = `${this.reportingUrl}/reporting/dealer/eu-reservations-report`;
    return axios
      .post(url, requestBody, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }

  static downloadPurchaseRequestReportInCsv(user, lang) {
    const commonIds = user.getCommonIdsWithSDLR
      ? user.getCommonIdsWithSDLR().split(",")
      : user.commonId.split("|").join("%7C");
    const url = `${this.baseUrl}/dealer/purchase-request-report?dealerCommonId=${commonIds}&lang=${lang}`;
    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }

  static downloadDealerReservationReportInCsv(user, lang) {
    const commonIds = user.getCommonIdsWithSDLR
      ? user.getCommonIdsWithSDLR().split(",")
      : user.commonId.split("|").join("%7C");
    const url = `${this.baseUrl}/dealer/dealer-reservation-report?dealerCommonId=${commonIds}&lang=${lang}`;
    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }

  static downloadOrderConversionReportInCsv(user, lang) {
    const commonIds = user.getCommonIdsWithSDLR
      ? user.getCommonIdsWithSDLR().split(",")
      : user.commonId.split("|").join("%7C");
    const url = `${this.baseUrl}/dealer/dealer-order-conversion-report?dealerCommonId=${commonIds}&lang=${lang}`;
    return axios
      .get(url, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }

  static updateOrderDetailsCustomerInfo(user, requestBody, guid) {
    const url = `${this.reportingUrl}/reporting/updateCustomerInfo?guid=${guid}`;

    return axios
      .post(url, requestBody, getHeaders(user.token))
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }
}
